// Language <-> URL helpers. uz is the default (no prefix); ru lives under /ru.
export const LANGS = ["uz", "ru"] as const;
export type Lang = (typeof LANGS)[number];
export const DEFAULT_LANG: Lang = "uz";

/** Derive the active language from a pathname. */
export function langFromPath(pathname: string): Lang {
  return pathname === "/ru" || pathname.startsWith("/ru/") ? "ru" : "uz";
}

/** Strip the /ru prefix to get the canonical (uz) path. */
export function stripLang(pathname: string): string {
  if (pathname === "/ru") return "/";
  if (pathname.startsWith("/ru/")) return pathname.slice(3);
  return pathname || "/";
}

/** Build the URL for a given language from any pathname. */
export function localizedPath(pathname: string, lang: Lang): string {
  const base = stripLang(pathname);
  if (lang === "ru") return base === "/" ? "/ru" : `/ru${base}`;
  return base;
}
